import React from 'react'
import { NodeHandle } from 'react-native'

// react-native-web no longer supports findNodeHandle, so this is our poor-mans no-op polyfill
export default function findNodeHandle(
  _componentOrHandle:
    | null
    | number
    | React.Component<any, any>
    | React.ComponentClass<any>
): null | NodeHandle {
  return null
}
